module.exports = __webpack_public_path__ + "static/media/img27.0a3ad0a0.JPG";